/* 人教版大纲薄弱知识 */
/* Author: renwanfeng */
/* create:2021/06/16 */
<template>
  <div class="flex-center flex-column mainbody">
    
    <!--标题 -->
    <div id="header">
      <div class="header-title-word"><span style="fontSize: 20px; ">{{u_name}}本学期薄弱知识点复习</span></div>
      <div class="bg"><img src="../../../../static/images/PeasonalizedTarget-background.png"></div>
    </div>

    <!--引入语 -->
    <div class="text-border-panel">
      <div class="maintext">
        <div v-if="tips == ''">
          恭喜{{u_name}}宝贝完成这一阶段的学习，老师根据宝贝在51Talk外教老师的反馈和单元诊断情况，整理了本学期需重点复习的一些薄弱知识点（包含词汇、句子和核心语法点）。这些知识点咱们宝贝掌握的还不是很好，需要复习巩固加强！
        </div>
        <div v-if="tips" style="text-indent: 2px;font-size: 15px" v-html="addDiv(tips)"/>
        </div>
        <div id="resource">
            <!--单词 key_word-->
            <div class="resource_cartoon" v-if="key_word.length > 0">
              <p>
                <span class="resource-title">
                  <span class="fa fa-star"></span>
                  <strong>薄弱词汇:</strong>
                </span>
              </p>
              <!-- <p class="maintext">薄弱单词复习方法：点小喇叭听单词发音，读几遍，看图片猜意思。点击图片进入单词学习页面复习单词的意思和相关例句。好记性不如烂笔头，抄写一下咱们的印象就加深了！</p> -->
              <div class="word-img-row">
                <div class="word-div"
                    v-for="word in key_word"
                    :key="word">
                  <a class="word-href"
                    :href="'/resource/word_v2/' + word.id_cipher + tailUrl"
                    @click="content_href_learning('word',word.uuid)">
                    <img class="word-img"
                        v-if="level == '-1' && word.word_picture_link_levelk != ''"
                        :src="word.word_picture_link_levelk"></img>
                    <img class="word-img"
                        v-else-if="word.word_picture_link"
                        :src="word.word_picture_link"></img>
                    <img class="word-img"
                        v-else
                        src="http://s.kg.51talkjr.com/85703bb4-c163-45f5-9f60-f208cda0d9d0.jpeg"></img>
                    <div class="word-img-div">
                      <div class="word-sound-img">
                        <i v-if="word.cej_ph_en"
                          class="word-sound"
                          @click.stop.prevent="sound_custom(word.cej_ph_en,'word',word.uuid)"></i>
                      </div>
                    </div>
                    <div class="word-text-div"
                        v-bind:style="{fontSize: changeFontSize(word.word_name) + 'px'}">
                      <span v-if="word.is_wrong == 1"
                            class="orange-bold">{{word.word_name}}
                      </span>
                      <span v-else
                            class="blue-bold">{{word.word_name}}
                      </span>
                    </div>
                  </a>
                </div>
              </div>
            </div>

            <!--核心句子 sentence-->
            <div class="resource_book" v-if="sentence.length > 0">
              <p><span class="resource-title">
                  <span class="fa fa-star"></span>
                  <strong>薄弱句子:</strong></span>
              </p>

              <div class="maintext">
                <div class="p-container"
                    v-for="(item,i) in sentence"
                    :key="i">
                  <p class="p-english family-english size-english">
                    <span class="p-order">{{i+1}}.</span>
                    <a :href="'/resource/sentence/' + item.id_cipher+ tailUrl+'&adminid=123'"
                      @click="content_href_learning('sentence',item.uuid)">
                      <span v-if='item.is_wrong==1'
                            class="orange-bold">{{item.sentence_en}}</span>
                      <span v-else
                            class="blue-bold">{{item.sentence_en}}</span>
                    </a>
                    <!-- :data-analytics='`{"action":"CK_UNIT_KNOWLEDGE_SENTENCE_SOUND","type":"sentence","id": ${item.id}}`' -->
                    <i v-if="item.sentence_en_mp3"
                      class="word-sound"
                      @click.stop.prevent="sound_custom(item.sentence_en_mp3,'sentence',item.uuid)"></i>
                  </p>
                  <p class="sentence-answer"
                    v-if="item.sentence_en_answer != null">{{item.sentence_en_answer}}
                    <!-- style="color: RGB(27, 70, 125)"  p-chinese family-chinese size-chinese  -->
                    <!-- <span v-text="item.sentence_en_answer"></span> -->
                    <i v-if="item.sentence_en_answer_mp3"
                      class="word-sound"
                      @click.stop.prevent="sound_custom(item.sentence_en_answer_mp3,'sentence',item.uuid)"></i>
                  </p>
                </div>
              </div>
            </div>

            <!--句型 sentence_structure -->
            <div class="resource_song" v-if="sentence_structure.length > 0">
              <p><span class="resource-title">
                  <span class="fa fa-star"></span>
                  <strong>薄弱句型:</strong></span>
              </p>
              <div class="maintext">
                <div class="p-container" v-for="(item,index) in sentence_structure">
                  <p class="p-english family-english size-english">
                    <span class="p-order">{{index+1}}.</span>
                      <span v-if="item.is_wrong == 1" class="orange-bold"> {{item.sentence_structure}}({{item.meaning}}) </span>
                      <span v-else class="blue-bold"> {{item.sentence_structure}} ({{item.meaning}}) </span>
                  </p>
                </div>
              </div>
            </div>

            <!--语法 grammar_level-->
            <div class="resource_activity" v-if="grammar_level.length > 0">
              <p>
                <span class="resource-title">
                  <span class="fa fa-star"></span>
                  <strong>薄弱语法点:</strong>
                </span>
              </p>

              <div class="maintext">
                <div class="p-container"
                    v-for="(item,k) in grammar_level"
                    :key="k">
                  <p class="p-english family-english size-english">
                    <a :href="'/resource/grammar/' + item.id_cipher + tailUrl"
                      @click="content_href_learning('grammar',item.uuid)">
                      <span v-if="item.is_wrong == 1"
                            class="orange-bold">
                        <span class="p-order">{{k+1}}.</span> {{item.grammar_level_en}}({{item.grammar_level}})
                      </span>
                      <span v-else
                            class="blue-bold">
                        <span class="p-order">{{k+1}}.</span> {{item.grammar_level_en}}({{item.grammar_level}})
                      </span>
                    </a>
                  </p>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
</template>

<script>
import BaseVue from '@/components/BaseVue'
require('@/assets/css/peasonalized-target.css')
var weakData = require('../mock/error')

export default {
  name: 'WeakKnowledgeREview',
  extends: BaseVue,
  data() {
    return {
        tips: '',
        u_name: '',
        sig: '',
        isfinal: '',
        url_params: ' ',
        user_id: '',
        level: '-1',
        key_word: [],
        sentence: [],
        grammar_level: [],
        sentence_structure: []
    }
  },
  computed: {
    tailUrl: function () {
      return this.url_params === '' ? '' : '?' + this.url_params
    },
  },
  created: function () {
    // var weakdata = new weakData()
    // this.Data = weakdata.data
    this.isfinal = this.$route.query.isfinal
    this.sig = this.$route.query.sig
    this.user_id = this.$route.query.uid
    this.u_name = this.$route.query.u_name
    this.url_params = this.$route.fullPath.split('?')[1]
    // let that = this
    // 增加人教版每个单元的报告埋点
    pindData.add_params({ t: 'FRR.000001' })
    pindData.pind_send( {
      "action": "PG_FINAL_REVIEW_REPORT_WEAKNESS", 
      "user_id": this.user_id,
      "isfinal": this.isfinal
      } );
    // let that=this
    let url = this.APIHOST + 'pep_unit_poor_knowledge?userid=' + this.user_id  //online mode
    // let url = 'http://10.0.2.70:8033/api/cms/pep_unit_poor_knowledge?userid='+this.user_id  //test mode
    fetch(url, {
        method: "get",
        mode: "cors",
      }).then((res) => res.json())
        .then((data) => {
          if(data.error_code == 10000){
            this.key_word = data.ret.key_word
            this.sentence = data.ret.sentence
            this.grammar_level =  data.ret.grammar_level
            this.sentence_structure = data.ret.sentence_structure
          }
          // this.Data = data.ret
          // console.log('error result data',)
          //完全没有薄弱点的时候 给用户提示
          if(data.error_code == -10014){
          // if(this.Data.key_word.length == 0 && this.Data.sentence.length == 0 && this.Data.grammar_level.length == 0){
            this.tips =
              '<p>宝贝学习太棒了！在51Talk所学的本学期的<span class="orange-bold">薄弱知识</span>都完全掌握咯！继续加油吧！</p>'
          }
        }
      )
  },
  methods: {
    changeFontSize: function (word_name) {
      //9*15 = word_name.length * X
      if (word_name.length > 9) return parseInt((9 * 15) / word_name.length)
    },
    sound: function (url) {
      var audio = new Audio(url)
      audio.play() //autoplay自动播放 loop循环播放  pause暂停
    },
    sound_custom: function (url, type,id) {
      var audio = new Audio(url)
      audio.play() //autoplay自动播放 loop循环播放  pause暂停
      //点击单元知识掌握报告页面某个知识的发音（目前只有单词、语法和句子)
      let action =
        'CK_FINAL_REVIEW_REPORT_WEAKNESS_' + type.toLocaleUpperCase() + '_SOUND'
      pindData.pind_send({
        action: action,
        user_id: this.user_id,
        uuid: id //知识id
      })
    },
    content_href_learning: function (type,id) {
      //点击人教版每个单元知识的超链子页面学习（单词、语法、句子）
      let action = 'CK_FINAL_REVIEW_REPORT_WEAKNESS_' + type.toLocaleUpperCase()
      pindData.pind_send({
        action: action,
        user_id: this.user_id,
        uuid: id  //知识id
      })
    },
    // getUrlParam(name) {
    //   //a标签跳转获取参数？？？
    //   var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    //   var r = window.location.search.substr(1).match(reg)
    //   if (r != null) return r[2]
    //   return null
    // },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->




// WEBPACK FOOTER //
// src/components/template/target/WeakKnowledgeREview.vue